import { useState } from "react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import IconButton, { type IconButtonVariant } from "./IconButton";
import { type Color } from "./Text";

interface CopyToClipboardProps {
  toCopy: string;
  variant?: IconButtonVariant;
  color?: Color;
}

export default function CopyToClipboard({
  toCopy,
  variant,
  color = "neutral",
}: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(toCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.error("Cannot copy to clipboard", e);
    }
  }

  return (
    <IconButton
      icon={copied ? IconCheck : IconCopy}
      label={copied ? "Copié" : "Copier"}
      color={copied ? "success" : color}
      variant={variant}
      onClick={copy}
    />
  );
}
